import * as yup from 'yup';
type TFunction = (key: string, options?: Record<string, unknown>) => string;

export const initialVideoStepValues = {
  name: '',
  duration: 0,
  rank: 0,
  required: false,
  positiveExplanation: '',
  negativeExplanation: '',
};

export const videoStepSchema = (translate: TFunction) => {
  return yup.object().shape({
    name: yup.string().required(translate('REQUIRED')),
    duration: yup.number().positive().max(60).required(translate('REQUIRED')),
    rank: yup.number().positive().required(translate('REQUIRED')),
    required: yup.boolean().required(translate('REQUIRED')),
    positiveExplanation: yup.string().required(translate('REQUIRED')),
    negativeExplanation: yup.string().required(translate('REQUIRED')),
  });
};
